import { ArrowsChevronLeft, Link } from 'neon-design-system';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  link: {
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center'
  },
  icon: {
    width: theme.spacing(1.5),
    height: theme.spacing(1.5),
    marginRight: theme.spacing(0.5)
  }
}));

interface BackButtonProps {
  to: string;
  pageName: string;
  onClick?: () => void;
  className?: string;
}

export const BackButton = ({ to, pageName, onClick, className }: BackButtonProps) => {
  const classes = useStyles();
  const clickHandler = !onClick
    ? {}
    : {
        onClick: (e: any) => {
          e.preventDefault();
          onClick?.();
        }
      };

  return (
    <Link className={[classes.link, className].join(' ')} to={to} {...clickHandler}>
      <ArrowsChevronLeft className={classes.icon} /> Back to {pageName}
    </Link>
  );
};
